import { useStaticQuery, graphql } from "gatsby"

const useBlogsEcoAlliance = () => {
  const query = useStaticQuery(graphql`
  query bizAdvice1 {
    posts: allGhostPost(
        filter: { tags: { elemMatch: { slug: {eq: "eco-alliance"} } } }
        sort: { order: DESC, fields: [published_at] }
        limit: 2000
        skip: 0
    ) {
        edges {
            node {
                id
                title
                slug
                feature_image
                excerpt
                published_at(formatString: "DD MMMM YYYY")
                primary_author {
                    name
                    slug
                    profile_image
                }
                tags {
                    name
                    slug
                }
                url
            }
        }
    }
  }
  `);

  return query;
}

export default useBlogsEcoAlliance;
